import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { IonContent, IonGrid, IonRow, IonCol, IonInput, IonButton } from "@ionic/angular/standalone";
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { TranslocoDirective } from "@jsverse/transloco";

import { BaseModalComponent } from "@mp/common/base/base-modal.component";
import { AppAuthService } from "@mp/core/auth/auth.service";
import { UserEntity } from "@mp/common/entities/user.entity";
import { UserAvatarComponent } from "../user-avatar/user-avatar.component";

@Component({
    selector: "mp-profile-modal",
    templateUrl: "./profile-modal.component.html",
    styleUrls: ["./profile-modal.component.scss"],
    imports: [IonContent, IonGrid, IonRow, IonCol, IonInput, IonButton, ReactiveFormsModule, UserAvatarComponent, TranslocoDirective]
})
export class ProfileModalComponent extends BaseModalComponent implements OnInit, OnDestroy {
    public formGroup!: FormGroup;
    public user!: UserEntity;
    public formDisabled = true;

    private readonly appAuthService = inject(AppAuthService);
    private readonly formBuilder = inject(FormBuilder);

    private subscription: Subscription;

    constructor() {
        super();
    }

    public ngOnInit(): void {
        this.subscription = this.appAuthService.currentUser.subscribe(currentUser => {
            if (!currentUser) {
                return;
            }
            this.user = { ...currentUser };
            const [firstName, ...rest] = (currentUser.name ?? "").split(" ");
            this.formGroup = this.formBuilder.group({
                firstName: [firstName || "", Validators.required],
                lastName: [rest.join(" ") || ""],
                email: [currentUser.email || "", [Validators.required, Validators.email]]
            });

            //FIXME: This form would be enabled in future versions
            if (true) {
                this.formGroup.disable();
            }
        });
    }

    public ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    public onImageSelected(event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (): void => {
            this.user = { ...this.user, avatarUrl: reader.result as string };
        };
        reader.readAsDataURL(file);
    }

    public onRemoveAvatar(): void {
        this.user = { ...this.user, avatarUrl: undefined };
    }

    public onSave(): void {
        if (!this.formGroup || this.formGroup.invalid) {
            this.formGroup.markAllAsTouched();
            return;
        }
        const { firstName, lastName, email } = this.formGroup.value;
        const updated: UserEntity = {
            ...this.user,
            name: [firstName, lastName].filter(Boolean).join(" "),
            email
        };
        this.appAuthService.saveLoggedUser(updated);
        this.closeModal();
    }

    public onBack(): void {
        this.closeModal();
    }
}
